export default __webpack_public_path__ + "static/media/placeholder-logo.621ac97f.png";